import _ from 'lodash'
import Vue from 'vue'

export const genericError = 'Sorry, we hit a snag. Please try again.'

export const noInternetError = "It looks like you aren't connected to the internet."

export const errorTranslations = {
    'This field may not be null.': 'Whoops, please fill this out.',
    'This field may not be blank.': 'Whoops, please fill this out.',
    'This field is required.': 'Whoops, please fill this out.',
    'Incorrect type. Expected pk value, received str.': 'Whoops, please fill this out.',
    'Please enter a correct email and password. Note that both fields may be case-sensitive.': "Hmm, that information doesn't seem right. Please try again.", // eslint-disable-line
}

export const translateErrors = (errors, customTranslations) => {
    // Recurse through nested objects
    if (typeof errors === 'object' && !_.isArray(errors)) {
        _.each(errors, (val, key) => {
            errors[key] = translateErrors(val)
        })
        return errors
    }

    // Translate everything else
    const translations = { ...errorTranslations, ...customTranslations }
    if (typeof errors === 'string') errors = [errors]
    let join = true
    errors = _.map(errors, (error) => {
        // Recurse through arrays
        if (typeof error === 'object') {
            join = false
            return translateErrors(error)
        }
        return translations[error] || error
    })
    return join ? errors.join('\n') : errors
}

export const parseError = (error, customTranslations) => {
    // Extract the information from the error
    let data = {}
    let status = null
    if (error.response) ({ data, status } = error.response)

    // Extract the top-level and field errors
    let overallError = null
    const fieldErrors = {}

    if (status >= 500) {
        overallError = genericError
    } else if (status === 400) {
        if (typeof data === 'string') {
            overallError = [data]
        } else if (!_.isArray(data)) {
            _.each(data, (err, field) => {
                if (field === 'non_field_errors' || field === '__all__') {
                    overallError = err
                } else {
                    fieldErrors[field] = err
                }
            })
        } else {
            overallError = data
        }
    } else if (status === 429) {
        overallError = "You're doing things a bit too quickly."
    } else if (status === 418) {
        overallError = 'Please refresh the page and try again.'
    } else if (status === 413) {
        overallError = 'Your photo is too large, please choose a smaller one.'
    } else if (data.detail) {
        overallError = data.detail
    } else if (status !== null) {
        overallError = genericError
    } else {
        overallError = noInternetError
    }

    // Make the raw objects available
    const result = {
        raw: { overallError, fieldErrors },
        status,
    }

    // Make translated versions available
    const tFieldErrors = { ...fieldErrors }
    _.each(tFieldErrors, (val, field) => {
        tFieldErrors[field] = translateErrors(val, customTranslations)
    })
    result.translated = {
        overallError: translateErrors(overallError, customTranslations),
        fieldErrors: tFieldErrors,
    }

    // Make a squashed version available
    result.squashed = result.translated.overallError
    if (!result.squashed) {
        result.squashed = translateErrors(_.map(result.translated.fieldErrors, (v, k) => `${k}: ${v}`).join('\n'), customTranslations)
    }

    return result
}

export const ensure = async (promise) => {
    try {
        return await promise
    } catch (e) {
        Vue.$toast.error(parseError(e).squashed)
        throw e
    }
}

Vue.prototype.$drf = { parseError, ensure }
